import useLanguage from "../i18n/useLanguage";
import { products } from "../data/products";
import ProductCard from "./products/ProductCard";

export default function Products() {
  const { t } = useLanguage();
  return (
    <section id="products" aria-labelledby="products-title" className="scroll-mt-24 bg-black text-white py-20 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <p className="text-sm uppercase tracking-[0.25em] text-gray-400 mb-4">{t("Dibuat oleh Titik Senyap Studio")}</p>
          <h2 id="products-title" className="text-4xl sm:text-6xl font-bold text-amber-300 mb-5">{t("Our Products")}</h2>
          <p className="text-gray-400 text-lg leading-relaxed">{t("Dari konten AI hingga aplikasi, website, dan bot. Kenali produk kami dan langsung mulai dari sini.")}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
          {products.map(product => <ProductCard key={product.id} product={product} />)}
        </div>
      </div>
    </section>
  );
}
